import React, { FC, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { PrimaryButton } from '../atoms/Button';
import { useSmartFormContext } from './utils';

export const FormDefaultSubmit: FC<React.PropsWithChildren<{ onClick?: () => any; waitingForCaptcha?: boolean }>> = ({
  onClick,
  waitingForCaptcha
}) => {
  const { submitForm, isSubmitting, isValidating, errors } = useFormikContext();
  const context = useSmartFormContext();

  const readonly = context?.readonly;
  const translations = context?.translations;
  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    onClick?.();
    submitForm();
  };

  // TODO: Refactor to instead autoFocus on first field & to be a reusable component
  useEffect(() => {
    if (isSubmitting && !isValidating) {
      if ((errors as any)?.flat) {
        const errorKeys = Object.keys((errors as any)?.flat);
        if (errorKeys.length) {
          const errorElement = document.querySelector(`[id="${errorKeys[0]}"]`) as HTMLElement;
          if (errorElement) {
            errorElement?.scrollIntoView?.();
          }
        }
      }
    }
  }, [isSubmitting, isValidating, errors]);

  return (
    <PrimaryButton.Contained
      data-test="form-submit"
      fullWidth
      disabled={!!waitingForCaptcha || isValidating || isSubmitting || readonly}
      onClick={handleClick}
    >
      {translations?.submitLabel || 'Submit'}
    </PrimaryButton.Contained>
  );
};
